module.exports = __webpack_public_path__ + "media/images/games/rocket-league/rectangle-33e029863f6f49030ac156f3f69c5510.jpg";